import { useParams } from 'react-router-dom';

import EventScreen from '../features/evento/layouts/screen';

// TSS vite/01 — thin page. Pantalla de PROYECCIÓN del evento (1920×1080, oscura),
// read-only, por public_token. Standalone (sin shell). Para el salón; el registro
// y la puja van en /evento/:token.
export default function EventoPantallaPage() {
    const { token } = useParams();
    return <EventScreen token={token} />;
}
